import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import {
  faStar,
  faClock,
  faTimesCircle,
  faFileAlt,
} from '@fortawesome/free-regular-svg-icons';

const Section = ({ title, icon, children, defaultOpen }) => {
  const [open, setOpen] = useState(!!defaultOpen);

  return (
    <div className="prop-section">
      <button
        className={`prop-section-header${open ? ' open' : ''}`}
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
        type="button"
      >
        <FontAwesomeIcon icon={icon} className="prop-section-icon" aria-hidden="true" />
        <span className="prop-section-title">{title}</span>
        <FontAwesomeIcon icon={faChevronDown} className="prop-section-chevron" aria-hidden="true" />
      </button>
      {open && <div className="prop-section-body">{children}</div>}
    </div>
  );
};

const PropertyInfo = ({ property }) => {
  const { t } = useTranslation();
  const {
    aboutInfoText,
    amenities,
    checkinDetailsInfoText,
    cancelationPolicyInfoText,
    termsInfoText,
  } = property;

  const hasAbout      = !!aboutInfoText;
  const hasAmenities  = amenities && amenities.length > 0;
  const hasCheckin    = !!checkinDetailsInfoText;
  const hasCancelation = !!cancelationPolicyInfoText;
  const hasTerms      = !!termsInfoText;

  if (!hasAbout && !hasAmenities && !hasCheckin && !hasCancelation && !hasTerms) {
    return null;
  }

  return (
    <div className="prop-info-accordion">
      {hasAbout && (
        <Section
          title={t('propertyInfo.about')}
          icon={faInfoCircle}
          defaultOpen
        >
          <div className="prop-section-text">{parse(aboutInfoText)}</div>
        </Section>
      )}

      {hasAmenities && (
        <Section
          title={t('propertyInfo.amenities')}
          icon={faStar}
          defaultOpen
        >
          <ul className="prop-amenities-list list-unstyled m-0">
            {amenities
              .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0))
              .map((amenity, i) => (
                <li key={`pinfo-amenity-${i}`} className="prop-amenity-item">
                  <span className={amenity.icon} aria-hidden="true" />
                  <span className="prop-amenity-label">{amenity.label}</span>
                </li>
              ))}
          </ul>
        </Section>
      )}

      {hasCheckin && (
        <Section
          title={t('propertyInfo.checkin')}
          icon={faClock}
        >
          <div className="prop-section-text">{parse(checkinDetailsInfoText)}</div>
        </Section>
      )}

      {hasCancelation && (
        <Section
          title={t('propertyInfo.cancelation')}
          icon={faTimesCircle}
        >
          <div className="prop-section-text">{parse(cancelationPolicyInfoText)}</div>
        </Section>
      )}

      {hasTerms && (
        <Section
          title={t('propertyInfo.terms')}
          icon={faFileAlt}
        >
          <div className="prop-section-text">{parse(termsInfoText)}</div>
        </Section>
      )}
    </div>
  );
};

export default PropertyInfo;
